import React from 'react';
import { Box, Button, Menu, Text } from 'grommet';
import { Update } from 'grommet-icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from 'granite-admin/core/components/Tooltip';
const StyledButton = styled(Button)`
  background-color: ${props => props.active && props.theme.global.colors['brand']};
  padding: 0.2rem 0.5rem;
  border: ${props => `1px solid ${props.theme.global.colors['border']}`};
  font-size: 10px;
  border-radius: 0;
  box-shadow: ${props => props.active && '0px 3px 6px #00000029'};
  color: ${props => props.active ? 'white' : props.theme.global.colors['text']};
  &.nav-button {
    border-radius: ${props => props.label === 'Previous' ? `4px 0 0 4px` : `0 4px 4px 0`};
  }
  pointer-events: ${props => props.active && 'none'};
`;
const RefreshButton = styled(Button)`
  border: 1px solid ${props => props.theme.global.colors['brand']};
  border-radius: 4px;
  padding: 5px;
`;
const StyledMenu = styled(Menu)`
  > div {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
const Pagination = ({
  onPageChange,
  pageData: {
    page = 1,
    page_size = 10,
    total
  },
  pageSizeOptions,
  showSizeChanger,
  onRefresh,
  maxPages,
  ...rest
}) => {
  const totalPages = Math.ceil(total / page_size);
  const goToPrevPage = () => onPageChange({
    page: page - 1,
    page_size
  });
  const goToNextPage = () => onPageChange({
    page: page + 1,
    page_size
  });
  const goToPage = page => onPageChange({
    page: page,
    page_size
  });
  const changeSize = val => onPageChange({
    page: 1,
    page_size: parseInt(val)
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    wrap: true,
    justify: "between",
    margin: {
      top: 'small'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "xsmall"
  }, onRefresh && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Refresh",
    align: "bottom"
  }, /*#__PURE__*/React.createElement(RefreshButton, {
    plain: false,
    size: "small",
    icon: /*#__PURE__*/React.createElement(Update, {
      size: "12px",
      color: "brand"
    }),
    onClick: onRefresh
  })), showSizeChanger && /*#__PURE__*/React.createElement(StyledMenu, {
    size: "small",
    label: /*#__PURE__*/React.createElement(Box, {
      flex: true,
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, page_size, "/Page")),
    items: pageSizeOptions.filter(option => option !== page_size).map(option => ({
      label: /*#__PURE__*/React.createElement(Box, {
        flex: true,
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, option, "/Page")),
      onClick: () => changeSize(option)
    }))
  })), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "row",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span"
  }, "Total Records: ", total), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "row"
  }, /*#__PURE__*/React.createElement(StyledButton, {
    className: "nav-button",
    size: "small",
    label: "Previous",
    onClick: goToPrevPage,
    disabled: page === 1
  }), pagination(page, totalPages, maxPages).map(item => /*#__PURE__*/React.createElement(StyledButton, {
    size: "small",
    active: item === page,
    key: item,
    onClick: () => goToPage(item),
    label: item
  })), /*#__PURE__*/React.createElement(StyledButton, {
    className: "nav-button",
    size: "small",
    label: "Next",
    onClick: goToNextPage,
    disabled: page === totalPages || totalPages < 1
  }))));
};
function pagination(currentPage, totalPages, maxPages) {
  // const maxPages =
  let start, end;
  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    start = 1;
    end = totalPages;
  } else {
    // total pages more than max so calculate start and end pages
    let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      start = 1;
      end = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      start = totalPages - maxPages + 1;
      end = totalPages;
    } else {
      // current page somewhere in the middle
      start = currentPage - maxPagesBeforeCurrentPage;
      end = currentPage + maxPagesAfterCurrentPage;
    }
  }
  let pages = Array.from(Array(end + 1 - start).keys()).map(i => start + i);
  return pages;
}
Pagination.defaultProps = {
  onPageChange: () => {},
  pageData: {},
  showSizeChanger: false,
  maxPages: 3,
  pageSizeOptions: [10, 20, 50, 100]
};
Pagination.propTypes = {
  onPageChange: PropTypes.func,
  pageData: PropTypes.object,
  showSizeChanger: PropTypes.bool,
  pageSizeOptions: PropTypes.array,
  onRefresh: PropTypes.func,
  maxPages: PropTypes.number
};
export default Pagination;